import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de281153b1c854/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de281153b1c854/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de281153b1c854/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabletCaseStudy"] */ "/tmp/8de281153b1c854/components/sections/TabletCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabletShowcase"] */ "/tmp/8de281153b1c854/components/sections/TabletShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Section.module.css");
